@if (entries.length) {
    <section class="completed-section">
        @if (entries.length > 0) {
            <div class="section-title">{{ appStringAPI.getAppString(header) }}</div>

            <app-carousel [config]="splideConfig">
                @for (item of entries; track $index) {
                    <app-slide>
                        <app-scheduled-entry
                          (click)="routeLink(item)"
                          [entry]="item"
                          [format]="'square'"
                          [showTourTypes]="entry_type === 'upcoming_entries' || entry_type === 'completed_entries'"
                          [attr.data-schedule-entry-id]="item.id">
                        </app-scheduled-entry>
                    </app-slide>
                }
            </app-carousel>
        }
    </section>
}
